// src/api/sse.js
import { apiUrl } from "./http";

export function openFleetSSE() {
  return new EventSource(apiUrl("/api/fleet/live/events"));
}